/**
 * Luxury Bed Cart Handler
 * Adds main product + luxury headboard height addon + mattress addon + luxury gas lift storage addon
 * as separate line items
 */
(function () {
    'use strict';

    // Only run on luxury beds template (check for luxury height slider)
    if (!document.getElementById('luxury-height-slider')) return;

    var form = document.getElementById('headboard-product-form');
    if (!form) return;

    var LUXURY_HEIGHT_HANDLE = 'luxury-headboard-height';
    var LUXURY_GAS_LIFT_HANDLE = 'luxury-gas-lift-storage';
    var GAS_LIFT_FALLBACK_PRICE = 12000; // £120.00 in pence

    // Set up gas lift radio listeners
    setTimeout(function () {
        var gasLiftRadios = document.querySelectorAll('input[name="gas-lift-select"]');
        gasLiftRadios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                var label = document.getElementById('selected-gas-lift');
                var prop = document.getElementById('gas-lift-property');
                if (radio.value === 'none') {
                    if (label) label.textContent = 'None';
                    if (prop) prop.value = '';
                    document.getElementById('gas-lift-addon-id').value = '';
                    document.getElementById('gas-lift-addon-price').value = '0';
                    document.dispatchEvent(new CustomEvent('gas-lift-addon-updated', {
                        detail: { price: 0, variantId: null, title: 'None' }
                    }));
                } else {
                    if (label) label.textContent = radio.value;
                    if (prop) prop.value = radio.value;

                    // Immediately set fallback price
                    document.getElementById('gas-lift-addon-price').value = GAS_LIFT_FALLBACK_PRICE;
                    document.dispatchEvent(new CustomEvent('gas-lift-addon-updated', {
                        detail: { price: GAS_LIFT_FALLBACK_PRICE, variantId: null, title: radio.value }
                    }));

                    // Fetch the luxury gas lift product to get actual variant id and price
                    fetch('/products/' + LUXURY_GAS_LIFT_HANDLE + '.js')
                        .then(function (res) { return res.ok ? res.json() : null; })
                        .then(function (product) {
                            if (product) {
                                var matchVariant = product.variants.find(function (v) {
                                    return v.title === radio.value ||
                                        v.option1 === radio.value ||
                                        v.option2 === radio.value ||
                                        v.option3 === radio.value;
                                });
                                if (matchVariant) {
                                    document.getElementById('gas-lift-addon-id').value = matchVariant.id;
                                    document.getElementById('gas-lift-addon-price').value = matchVariant.price;
                                    document.dispatchEvent(new CustomEvent('gas-lift-addon-updated', {
                                        detail: { price: matchVariant.price, variantId: matchVariant.id, title: radio.value }
                                    }));
                                }
                            }
                        });
                }
            });
        });
    }, 50);

    // Set up add-to-cart button
    setTimeout(function () {
        var btn = document.getElementById('framebed-add-to-cart-btn');
        if (btn) btn.addEventListener('click', handleAddToCart, true);

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            handleAddToCart(e);
        }, true);
    }, 100);

    /**
     * Find the correct height variant by extracting the first number from each variant title
     * and matching it against the tier's starting height.
     */
    function findHeightVariant(variants, tierStart) {
        return variants.find(function (v) {
            var text = v.title || v.option1 || '';
            var match = text.match(/(\d+)/);
            if (match) {
                return parseInt(match[1]) === tierStart;
            }
            return false;
        });
    }

    /**
     * Get the tier start number for a given slider height value
     */
    function getTierStart(height) {
        if (height >= 60 && height <= 64) return null; // standard, no addon
        if (height >= 65 && height <= 69) return 65;
        if (height >= 70 && height <= 74) return 70;
        if (height >= 75 && height <= 79) return 75;
        if (height >= 80 && height <= 84) return 80;
        if (height >= 85 && height <= 89) return 85;
        if (height >= 90 && height <= 94) return 90;
        if (height >= 95 && height <= 100) return 95;
        return null;
    }

    function handleAddToCart(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var btn = document.getElementById('framebed-add-to-cart-btn');
        var originalText = btn ? btn.innerHTML : '';
        if (btn) { btn.innerHTML = '<span>Adding...</span>'; btn.disabled = true; }

        var formData = new FormData(form);
        var variantId = formData.get('id');
        var quantity = parseInt(formData.get('quantity')) || 1;

        // Collect form properties (skip empty and internal values)
        var properties = {};
        for (var pair of formData.entries()) {
            if (pair[0].startsWith('properties[')) {
                var name = pair[0].replace('properties[', '').replace(']', '');
                if (name !== '_price_addon' && pair[1] && pair[1].trim() !== '') {
                    properties[name] = pair[1];
                }
            }
        }

        // Check for mattress addon
        var mattressEl = document.getElementById('mattress-addon-id');
        var hasMattress = mattressEl && mattressEl.value && mattressEl.value !== '' && mattressEl.value !== '0';

        // Check for luxury height addon
        var heightAddonIdEl = document.getElementById('luxury-height-addon-id');
        var heightSlider = document.getElementById('luxury-height-slider');
        var sliderValue = heightSlider ? parseInt(heightSlider.value) : 60;
        var tierStart = getTierStart(sliderValue);
        var needsHeightAddon = tierStart !== null; // height > 64 means addon needed

        // Check for gas lift storage addon
        var gasLiftPropEl = document.getElementById('gas-lift-property');
        var gasLiftIdEl = document.getElementById('gas-lift-addon-id');
        var hasGasLift = gasLiftPropEl && gasLiftPropEl.value && gasLiftPropEl.value.trim() !== '';

        // Build promise chain for any addons that need fetching
        var promises = [];

        // If height addon needed but variant ID not set, fetch it
        if (needsHeightAddon && (!heightAddonIdEl.value || heightAddonIdEl.value === '' || heightAddonIdEl.value === '0')) {
            console.log('Height addon variant ID not set, fetching from product API. TierStart:', tierStart);
            promises.push(
                fetch('/products/' + LUXURY_HEIGHT_HANDLE + '.js')
                    .then(function (res) { return res.ok ? res.json() : null; })
                    .then(function (product) {
                        if (product && product.variants) {
                            var matchVariant = findHeightVariant(product.variants, tierStart);
                            if (matchVariant) {
                                heightAddonIdEl.value = matchVariant.id;
                                document.getElementById('luxury-height-addon-price').value = matchVariant.price;
                                console.log('Fetched height variant:', matchVariant.id, matchVariant.title);
                                return { type: 'height', variantId: matchVariant.id, price: matchVariant.price };
                            } else {
                                console.warn('No matching height variant found for tierStart:', tierStart);
                            }
                        }
                        return null;
                    })
            );
        } else if (needsHeightAddon) {
            console.log('Height addon variant already set:', heightAddonIdEl.value);
        }

        // If gas lift selected but variant ID not yet fetched, fetch it
        if (hasGasLift && (!gasLiftIdEl.value || gasLiftIdEl.value === '' || gasLiftIdEl.value === '0')) {
            promises.push(
                fetch('/products/' + LUXURY_GAS_LIFT_HANDLE + '.js')
                    .then(function (res) { return res.ok ? res.json() : null; })
                    .then(function (product) {
                        if (product) {
                            var matchVariant = product.variants.find(function (v) {
                                return v.title === gasLiftPropEl.value ||
                                    v.option1 === gasLiftPropEl.value ||
                                    v.option2 === gasLiftPropEl.value ||
                                    v.option3 === gasLiftPropEl.value;
                            });
                            if (matchVariant) {
                                gasLiftIdEl.value = matchVariant.id;
                                document.getElementById('gas-lift-addon-price').value = matchVariant.price;
                                return { type: 'gasLift', variantId: matchVariant.id, price: matchVariant.price };
                            }
                        }
                        return null;
                    })
            );
        }

        Promise.all(promises).then(function () {
            buildAndSubmit(variantId, quantity, properties, hasMattress, mattressEl, needsHeightAddon, heightAddonIdEl, hasGasLift, gasLiftIdEl, btn, originalText);
        }).catch(function (err) {
            console.error('Error preparing addons:', err);
            // Still try to submit without addons
            buildAndSubmit(variantId, quantity, properties, hasMattress, mattressEl, needsHeightAddon, heightAddonIdEl, hasGasLift, gasLiftIdEl, btn, originalText);
        });
    }

    function buildAndSubmit(variantId, quantity, properties, hasMattress, mattressEl, needsHeightAddon, heightAddonEl, hasGasLift, gasLiftEl, btn, originalText) {
        var items = [];

        // If mattress addon selected, add info to properties
        if (hasMattress) {
            var mattressTitle = document.getElementById('mattress-addon-title').value || 'Mattress';
            var mattressPrice = parseInt(document.getElementById('mattress-addon-price').value || '0');
            var formatted = '\u00a3' + (mattressPrice / 100).toFixed(2);
            properties['Mattress'] = mattressTitle + ' (+' + formatted + ')';
        }

        // If gas lift addon selected, add info to properties
        if (hasGasLift) {
            var gasLiftProp = document.getElementById('gas-lift-property');
            var gasLiftPrice = parseInt(document.getElementById('gas-lift-addon-price').value || '0');
            var gasFormatted = '\u00a3' + (gasLiftPrice / 100).toFixed(2);
            var gasLiftValue = gasLiftProp ? gasLiftProp.value : '';
            properties['Gas Lift Storage'] = gasLiftValue + ' (+' + gasFormatted + ')';
        }

        // Main product
        items.push({ id: parseInt(variantId), quantity: quantity, properties: properties });

        // Mattress addon line item
        if (hasMattress) {
            items.push({
                id: parseInt(mattressEl.value),
                quantity: quantity,
                properties: { 'Addon For': 'Luxury Bed' }
            });
        }

        // Height addon line item — check if variant ID is available
        var hasHeightVariant = needsHeightAddon && heightAddonEl && heightAddonEl.value && heightAddonEl.value !== '' && heightAddonEl.value !== '0';
        if (hasHeightVariant) {
            console.log('Adding height addon to cart:', heightAddonEl.value);
            items.push({
                id: parseInt(heightAddonEl.value),
                quantity: quantity,
                properties: { 'Addon For': 'Luxury Bed' }
            });
        } else if (needsHeightAddon) {
            console.warn('Height addon needed but no variant ID available!');
        }

        // Gas lift storage addon line item
        if (hasGasLift && gasLiftEl.value && gasLiftEl.value !== '' && gasLiftEl.value !== '0') {
            items.push({
                id: parseInt(gasLiftEl.value),
                quantity: quantity,
                properties: { 'Addon For': 'Luxury Bed' }
            });
        }

        console.log('Submitting cart items:', JSON.stringify(items, null, 2));

        // Submit all items
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
            .then(function (res) {
                if (!res.ok) {
                    return res.json().then(function (err) {
                        console.error('Cart add error:', err);
                        throw new Error(err.description || 'Failed to add to cart');
                    });
                }
                window.location.href = '/cart';
            })
            .catch(function (err) {
                alert('Error adding to cart: ' + err.message);
                if (btn) { btn.innerHTML = originalText; btn.disabled = false; }
            });
    }
})();
